import { stringConstant } from '../constants';

export const accessToken = state => state.config.accessToken;
export const bankId = state => state.config.bankId;
export const accountId = state => state.config.accountId;
export const getAPIObject = state => {
  return {
    accessToken: accessToken(state),
    bankId: bankId(state),
    accountId: accountId(state),
    apiBaseUrl: state.config.configValues.bpiApiUrl,
    uuid: state.config.uuid,
    paasExternalUrl: state.config.configValues.ibApiUrl,
    paasInternalUrl: state.config.configValues.paasInternalUrl
  };
};

export const hideBackButton = () => {
  const urls = ['/error', '/good-news-page', '/request-received-page'];
  return urls.includes(window.location.pathname);
};
